import { Stack } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import Checkbox from 'packages/ui/Checkbox'

import useCategoryContact from './use-category-contact'

import { BaseCategoryHeader, BaseCategoryItemCheckbox, BaseCategoryItemRadio } from './components'
import React from 'react'
import { useTheme } from '@mui/system'

const HeaderInternal = ({ category, onReadChange }) => {
  const { t } = useTranslation()

  return (
    <BaseCategoryHeader
      label={t(`auth.admin.role.category.${category.name}`)}
      rightAdornment={
        <i
          className={'fa-solid fa-crown'}
          style={{ cursor: 'pointer', color: '#D98B06', fontSize: '12px' }}
          onClick={onReadChange}
        />
      }
    />
  )
}

const HeaderDefault = ({ category, onReadChange }) => {
  const { t } = useTranslation()
  const { watch } = useFormContext()
  const roles = watch('roles')

  const checked = Object.keys(category.roles).every(role => roles[role])
  const indeterminate = !checked && Object.keys(category.roles).some(role => roles[role])
  return (
    <BaseCategoryHeader
      label={t(`auth.admin.role.category.${category.name}`)}
      rightAdornment={<Checkbox checked={checked} indeterminate={indeterminate} onChange={onReadChange} />}
    />
  )
}

export const CategoryAdmin = () => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { watch, setValue } = useFormContext()
  const checked = watch('roles.admin')
  const handleClick = (e) => {
    e.stopPropagation()
    const newValue = !checked
    setValue('admin', newValue)
    setValue('roles.admin', newValue)
  }
  return (
    <Stack gap={1}>
      <BaseCategoryHeader
        borderColor={'#E4EEFA'}
        backgroundColor={'#F5F8FB'}
        color={theme.palette.primary.main}
        onClick={handleClick}
        label={
          <Stack direction={'row'} justifyContent={'space-between'} alignItems="center" flex={1}>
            <Stack direction="row" alignItems="center" gap={1}>
              {t('auth.admin.role.administrator')}
              <i className="fa-solid fa-crown" />
            </Stack>
            <Checkbox
              checked={checked}
              onChange={handleClick}
            />
          </Stack>
        }
      />
    </Stack>
  )
}
export const CategoryContact = () => {
  const { t } = useTranslation()
  const { roles  } = useCategoryContact()

  return (
    <Stack gap={1}>
      <BaseCategoryHeader label={t('auth.admin.role.category.admin_users')} />
      {roles.map(({ key, checked, label, onChange }) => (
        <BaseCategoryItemRadio
          key={key}
          checked={checked}
          label={label}
          onClick={onChange}
          onMouseEnter={() => {}}
          onMouseLeave={() => {}}
        />
      ))}
    </Stack >
  )
}

const RAN_ROLES = ['ran', 'ran_stime', 'ran_stime_ro']
const Category = ({ category, onRoleMouseEnter, onRoleMouseLeave }) => {
  const { watch, setValue, getValues } = useFormContext()
  const roles = watch('roles')
  const { t } = useTranslation()

  const checkRanRole = (role, checked) => {
    RAN_ROLES.forEach(ranRole => setValue(`roles.${ranRole}`, false, { shouldValidate: true, shouldDirty: true }))
    if (checked) {
      setValue(`roles.${role}`, true, { shouldValidate: true, shouldDirty: true })
    }
  }
  const handleHeaderReadChange = () => {
    const isChecked = Object.keys(category.roles).every(role => getValues(`roles.${role}`))
    Object.keys(category.roles).forEach(role => {
      setValue(`roles.${role}`, !isChecked, { shouldValidate: true, shouldDirty: true })
    })
    if (!isChecked) {
      checkRanRole(RAN_ROLES[0], true)
    }
  }

  const handleBodyReadChange = (role) => {
    if (RAN_ROLES.includes(role)) {
      checkRanRole(role, !roles[role])
    } else {
      setValue(`roles.${role}`, !roles[role], { shouldValidate: true, shouldDirty: true })
    }
  }

  return (
    <Stack gap={.5}>
      {category.name === 'internal' ? (
        <HeaderInternal onReadChange={handleHeaderReadChange} category={category} />
      ) : (
        <HeaderDefault onReadChange={handleHeaderReadChange} category={category} />
      )}
      <Stack>
        {Object.keys(category.roles).map(role => (
          <BaseCategoryItemCheckbox
            key={role}
            label={t(`auth.admin.role.${role}`)}
            checked={roles[role]}
            checkedSx={category.name === 'internal' ? { color: 'white', backgroundColor: '#D98B06' } : null}
            onClick={() => handleBodyReadChange(role)}
            onReadToggle={() => handleBodyReadChange(role)}
            onMouseEnter={() => onRoleMouseEnter(role)}
            onMouseLeave={() => onRoleMouseLeave(role)}
          />
        ))}
      </Stack>
    </Stack>
  )
}

export default Category
